import React from "react";

export const NoPostSelectedMessage = () => (
  <article className="col-12 border p-4">
    <p className="mb-0">No post selected...</p>
  </article>
);

export default NoPostSelectedMessage;
